var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-management-login-history-overview')
}
var staticRenderFns = []

export { render, staticRenderFns }